export default {
  name: 'themify',
  icons: [
    { name: 'ti-wand', tags: [] },
    { name: 'ti-volume', tags: [] },
    { name: 'ti-user', tags: [] },
    { name: 'ti-unlock', tags: [] },
    { name: 'ti-unlink', tags: [] },
    { name: 'ti-trash', tags: [] },
    { name: 'ti-thought', tags: [] },
    { name: 'ti-target', tags: [] },
    { name: 'ti-tag', tags: [] },
    { name: 'ti-tablet', tags: [] },
    { name: 'ti-star', tags: [] },
    { name: 'ti-spray', tags: [] },
    { name: 'ti-signal', tags: [] },
    { name: 'ti-shopping-cart', tags: [] },
    { name: 'ti-shopping-cart-full', tags: [] },
    { name: 'ti-settings', tags: [] },
    { name: 'ti-search', tags: [] },
    { name: 'ti-zoom-in', tags: [] },
    { name: 'ti-zoom-out', tags: [] },
    { name: 'ti-cut', tags: [] },
    { name: 'ti-ruler', tags: [] },
    { name: 'ti-ruler-pencil', tags: [] },
    { name: 'ti-ruler-alt', tags: [] },
    { name: 'ti-bookmark', tags: [] },
    { name: 'ti-bookmark-alt', tags: [] },
    { name: 'ti-reload', tags: [] },
    { name: 'ti-plus', tags: [] },
    { name: 'ti-pin', tags: [] },
    { name: 'ti-pencil', tags: [] },
    { name: 'ti-pencil-alt', tags: [] },
    { name: 'ti-paint-roller', tags: [] },
    { name: 'ti-paint-bucket', tags: [] },
    { name: 'ti-na', tags: [] },
    { name: 'ti-mobile', tags: [] },
    { name: 'ti-minus', tags: [] },
    { name: 'ti-medall', tags: [] },
    { name: 'ti-medall-alt', tags: [] },
    { name: 'ti-marker', tags: [] },
    { name: 'ti-marker-alt', tags: [] },
    { name: 'ti-arrow-up', tags: [] },
    { name: 'ti-arrow-right', tags: [] },
    { name: 'ti-arrow-left', tags: [] },
    { name: 'ti-arrow-down', tags: [] },
    { name: 'ti-lock', tags: [] },
    { name: 'ti-location-arrow', tags: [] },
    { name: 'ti-link', tags: [] },
    { name: 'ti-layout', tags: [] },
    { name: 'ti-layers', tags: [] },
    { name: 'ti-layers-alt', tags: [] },
    { name: 'ti-key', tags: [] },
    { name: 'ti-import', tags: [] },
    { name: 'ti-image', tags: [] },
    { name: 'ti-heart', tags: [] },
    { name: 'ti-heart-broken', tags: [] },
    { name: 'ti-hand-stop', tags: [] },
    { name: 'ti-hand-open', tags: [] },
    { name: 'ti-hand-drag', tags: [] },
    { name: 'ti-folder', tags: [] },
    { name: 'ti-flag', tags: [] },
    { name: 'ti-flag-alt', tags: [] },
    { name: 'ti-flag-alt-2', tags: [] },
    { name: 'ti-eye', tags: [] },
    { name: 'ti-export', tags: [] },
    { name: 'ti-exchange-vertical', tags: [] },
    { name: 'ti-desktop', tags: [] },
    { name: 'ti-cup', tags: [] },
    { name: 'ti-crown', tags: [] },
    { name: 'ti-comments', tags: [] },
    { name: 'ti-comment', tags: [] },
    { name: 'ti-comment-alt', tags: [] },
    { name: 'ti-close', tags: [] },
    { name: 'ti-clip', tags: [] },
    { name: 'ti-angle-up', tags: [] },
    { name: 'ti-angle-right', tags: [] },
    { name: 'ti-angle-left', tags: [] },
    { name: 'ti-angle-down', tags: [] },
    { name: 'ti-check', tags: [] },
    { name: 'ti-check-box', tags: [] },
    { name: 'ti-camera', tags: [] },
    { name: 'ti-announcement', tags: [] },
    { name: 'ti-brush', tags: [] },
    { name: 'ti-briefcase', tags: [] },
    { name: 'ti-bolt', tags: [] },
    { name: 'ti-bolt-alt', tags: [] },
    { name: 'ti-blackboard', tags: [] },
    { name: 'ti-bag', tags: [] },
    { name: 'ti-move', tags: [] },
    { name: 'ti-arrows-vertical', tags: [] },
    { name: 'ti-arrows-horizontal', tags: [] },
    { name: 'ti-fullscreen', tags: [] },
    { name: 'ti-arrow-top-right', tags: [] },
    { name: 'ti-arrow-top-left', tags: [] },
    { name: 'ti-arrow-circle-up', tags: [] },
    { name: 'ti-arrow-circle-right', tags: [] },
    { name: 'ti-arrow-circle-left', tags: [] },
    { name: 'ti-arrow-circle-down', tags: [] },
    { name: 'ti-angle-double-up', tags: [] },
    { name: 'ti-angle-double-right', tags: [] },
    { name: 'ti-angle-double-left', tags: [] },
    { name: 'ti-angle-double-down', tags: [] },
    { name: 'ti-zip', tags: [] },
    { name: 'ti-world', tags: [] },
    { name: 'ti-wheelchair', tags: [] },
    { name: 'ti-view-list', tags: [] },
    { name: 'ti-view-list-alt', tags: [] },
    { name: 'ti-view-grid', tags: [] },
    { name: 'ti-uppercase', tags: [] },
    { name: 'ti-upload', tags: [] },
    { name: 'ti-underline', tags: [] },
    { name: 'ti-truck', tags: [] },
    { name: 'ti-timer', tags: [] },
    { name: 'ti-ticket', tags: [] },
    { name: 'ti-thumb-up', tags: [] },
    { name: 'ti-thumb-down', tags: [] },
    { name: 'ti-text', tags: [] },
    { name: 'ti-stats-up', tags: [] },
    { name: 'ti-stats-down', tags: [] },
    { name: 'ti-split-v', tags: [] },
    { name: 'ti-split-h', tags: [] },
    { name: 'ti-smallcap', tags: [] },
    { name: 'ti-shine', tags: [] },
    { name: 'ti-shift-right', tags: [] },
    { name: 'ti-shift-left', tags: [] },
    { name: 'ti-shield', tags: [] },
    { name: 'ti-notepad', tags: [] },
    { name: 'ti-server', tags: [] },
    { name: 'ti-quote-right', tags: [] },
    { name: 'ti-quote-left', tags: [] },
    { name: 'ti-pulse', tags: [] },
    { name: 'ti-printer', tags: [] },
    { name: 'ti-power-off', tags: [] },
    { name: 'ti-plug', tags: [] },
    { name: 'ti-pie-chart', tags: [] },
    { name: 'ti-paragraph', tags: [] },
    { name: 'ti-panel', tags: [] },
    { name: 'ti-package', tags: [] },
    { name: 'ti-music', tags: [] },
    { name: 'ti-music-alt', tags: [] },
    { name: 'ti-mouse', tags: [] },
    { name: 'ti-mouse-alt', tags: [] },
    { name: 'ti-money', tags: [] },
    { name: 'ti-microphone', tags: [] },
    { name: 'ti-menu', tags: [] },
    { name: 'ti-menu-alt', tags: [] },
    { name: 'ti-map', tags: [] },
    { name: 'ti-map-alt', tags: [] },
    { name: 'ti-loop', tags: [] },
    { name: 'ti-location-pin', tags: [] },
    { name: 'ti-list', tags: [] },
    { name: 'ti-light-bulb', tags: [] },
    { name: 'ti-Italic', tags: [] },
    { name: 'ti-info', tags: [] },
    { name: 'ti-infinite', tags: [] },
    { name: 'ti-id-badge', tags: [] },
    { name: 'ti-hummer', tags: [] },
    { name: 'ti-home', tags: [] },
    { name: 'ti-help', tags: [] },
    { name: 'ti-headphone', tags: [] },
    { name: 'ti-harddrives', tags: [] },
    { name: 'ti-harddrive', tags: [] },
    { name: 'ti-gift', tags: [] },
    { name: 'ti-game', tags: [] },
    { name: 'ti-filter', tags: [] },
    { name: 'ti-files', tags: [] },
    { name: 'ti-file', tags: [] },
    { name: 'ti-eraser', tags: [] },
    { name: 'ti-envelope', tags: [] },
    { name: 'ti-download', tags: [] },
    { name: 'ti-direction', tags: [] },
    { name: 'ti-direction-alt', tags: [] },
    { name: 'ti-dashboard', tags: [] },
    { name: 'ti-control-stop', tags: [] },
    { name: 'ti-control-shuffle', tags: [] },
    { name: 'ti-control-play', tags: [] },
    { name: 'ti-control-pause', tags: [] },
    { name: 'ti-control-forward', tags: [] },
    { name: 'ti-control-backward', tags: [] },
    { name: 'ti-cloud', tags: [] },
    { name: 'ti-cloud-up', tags: [] },
    { name: 'ti-cloud-down', tags: [] },
    { name: 'ti-clipboard', tags: [] },
    { name: 'ti-car', tags: [] },
    { name: 'ti-calendar', tags: [] },
    { name: 'ti-book', tags: [] },
    { name: 'ti-bell', tags: [] },
    { name: 'ti-basketball', tags: [] },
    { name: 'ti-bar-chart', tags: [] },
    { name: 'ti-bar-chart-alt', tags: [] },
    { name: 'ti-back-right', tags: [] },
    { name: 'ti-back-left', tags: [] },
    { name: 'ti-arrows-corner', tags: [] },
    { name: 'ti-archive', tags: [] },
    { name: 'ti-anchor', tags: [] },
    { name: 'ti-align-right', tags: [] },
    { name: 'ti-align-left', tags: [] },
    { name: 'ti-align-justify', tags: [] },
    { name: 'ti-align-center', tags: [] },
    { name: 'ti-alert', tags: [] },
    { name: 'ti-alarm-clock', tags: [] },
    { name: 'ti-agenda', tags: [] },
    { name: 'ti-write', tags: [] },
    { name: 'ti-window', tags: [] },
    { name: 'ti-widgetized', tags: [] },
    { name: 'ti-widget', tags: [] },
    { name: 'ti-widget-alt', tags: [] },
    { name: 'ti-wallet', tags: [] },
    { name: 'ti-video-clapper', tags: [] },
    { name: 'ti-video-camera', tags: [] },
    { name: 'ti-vector', tags: [] },
    { name: 'ti-themify-logo', tags: [] },
    { name: 'ti-themify-favicon', tags: [] },
    { name: 'ti-themify-favicon-alt', tags: [] },
    { name: 'ti-support', tags: [] },
    { name: 'ti-stamp', tags: [] },
    { name: 'ti-split-v-alt', tags: [] },
    { name: 'ti-slice', tags: [] },
    { name: 'ti-shortcode', tags: [] },
    { name: 'ti-shift-right-alt', tags: [] },
    { name: 'ti-shift-left-alt', tags: [] },
    { name: 'ti-ruler-alt-2', tags: [] },
    { name: 'ti-receipt', tags: [] },
    { name: 'ti-pin2', tags: [] },
    { name: 'ti-pin-alt', tags: [] },
    { name: 'ti-pencil-alt2', tags: [] },
    { name: 'ti-palette', tags: [] },
    { name: 'ti-more', tags: [] },
    { name: 'ti-more-alt', tags: [] },
    { name: 'ti-microphone-alt', tags: [] },
    { name: 'ti-magnet', tags: [] },
    { name: 'ti-line-double', tags: [] },
    { name: 'ti-line-dotted', tags: [] },
    { name: 'ti-line-dashed', tags: [] },
    { name: 'ti-layout-width-full', tags: [] },
    { name: 'ti-layout-width-default', tags: [] },
    { name: 'ti-layout-width-default-alt', tags: [] },
    { name: 'ti-layout-tab', tags: [] },
    { name: 'ti-layout-tab-window', tags: [] },
    { name: 'ti-layout-tab-v', tags: [] },
    { name: 'ti-layout-tab-min', tags: [] },
    { name: 'ti-layout-slider', tags: [] },
    { name: 'ti-layout-slider-alt', tags: [] },
    { name: 'ti-layout-sidebar-right', tags: [] },
    { name: 'ti-layout-sidebar-none', tags: [] },
    { name: 'ti-layout-sidebar-left', tags: [] },
    { name: 'ti-layout-placeholder', tags: [] },
    { name: 'ti-layout-menu', tags: [] },
    { name: 'ti-layout-menu-v', tags: [] },
    { name: 'ti-layout-menu-separated', tags: [] },
    { name: 'ti-layout-menu-full', tags: [] },
    { name: 'ti-layout-media-right-alt', tags: [] },
    { name: 'ti-layout-media-right', tags: [] },
    { name: 'ti-layout-media-overlay', tags: [] },
    { name: 'ti-layout-media-overlay-alt', tags: [] },
    { name: 'ti-layout-media-overlay-alt-2', tags: [] },
    { name: 'ti-layout-media-left-alt', tags: [] },
    { name: 'ti-layout-media-left', tags: [] },
    { name: 'ti-layout-media-center-alt', tags: [] },
    { name: 'ti-layout-media-center', tags: [] },
    { name: 'ti-layout-list-thumb', tags: [] },
    { name: 'ti-layout-list-thumb-alt', tags: [] },
    { name: 'ti-layout-list-post', tags: [] },
    { name: 'ti-layout-list-large-image', tags: [] },
    { name: 'ti-layout-line-solid', tags: [] },
    { name: 'ti-layout-grid4', tags: [] },
    { name: 'ti-layout-grid3', tags: [] },
    { name: 'ti-layout-grid2', tags: [] },
    { name: 'ti-layout-grid2-thumb', tags: [] },
    { name: 'ti-layout-cta-right', tags: [] },
    { name: 'ti-layout-cta-left', tags: [] },
    { name: 'ti-layout-cta-center', tags: [] },
    { name: 'ti-layout-cta-btn-right', tags: [] },
    { name: 'ti-layout-cta-btn-left', tags: [] },
    { name: 'ti-layout-column4', tags: [] },
    { name: 'ti-layout-column3', tags: [] },
    { name: 'ti-layout-column2', tags: [] },
    { name: 'ti-layout-accordion-separated', tags: [] },
    { name: 'ti-layout-accordion-merged', tags: [] },
    { name: 'ti-layout-accordion-list', tags: [] },
    { name: 'ti-ink-pen', tags: [] },
    { name: 'ti-info-alt', tags: [] },
    { name: 'ti-help-alt', tags: [] },
    { name: 'ti-headphone-alt', tags: [] },
    { name: 'ti-hand-point-up', tags: [] },
    { name: 'ti-hand-point-right', tags: [] },
    { name: 'ti-hand-point-left', tags: [] },
    { name: 'ti-hand-point-down', tags: [] },
    { name: 'ti-gallery', tags: [] },
    { name: 'ti-face-smile', tags: [] },
    { name: 'ti-face-sad', tags: [] },
    { name: 'ti-credit-card', tags: [] },
    { name: 'ti-control-skip-forward', tags: [] },
    { name: 'ti-control-skip-backward', tags: [] },
    { name: 'ti-control-record', tags: [] },
    { name: 'ti-control-eject', tags: [] },
    { name: 'ti-comments-smiley', tags: [] },
    { name: 'ti-brush-alt', tags: [] },
    { name: 'ti-youtube', tags: [] },
    { name: 'ti-vimeo', tags: [] },
    { name: 'ti-twitter', tags: [] },
    { name: 'ti-time', tags: [] },
    { name: 'ti-tumblr', tags: [] },
    { name: 'ti-skype', tags: [] },
    { name: 'ti-share', tags: [] },
    { name: 'ti-share-alt', tags: [] },
    { name: 'ti-rocket', tags: [] },
    { name: 'ti-pinterest', tags: [] },
    { name: 'ti-new-window', tags: [] },
    { name: 'ti-microsoft', tags: [] },
    { name: 'ti-list-ol', tags: [] },
    { name: 'ti-linkedin', tags: [] },
    { name: 'ti-layout-sidebar-2', tags: [] },
    { name: 'ti-layout-grid4-alt', tags: [] },
    { name: 'ti-layout-grid3-alt', tags: [] },
    { name: 'ti-layout-grid2-alt', tags: [] },
    { name: 'ti-layout-column4-alt', tags: [] },
    { name: 'ti-layout-column3-alt', tags: [] },
    { name: 'ti-layout-column2-alt', tags: [] },
    { name: 'ti-instagram', tags: [] },
    { name: 'ti-google', tags: [] },
    { name: 'ti-github', tags: [] },
    { name: 'ti-flickr', tags: [] },
    { name: 'ti-facebook', tags: [] },
    { name: 'ti-dropbox', tags: [] },
    { name: 'ti-dribbble', tags: [] },
    { name: 'ti-apple', tags: [] },
    { name: 'ti-android', tags: [] },
    { name: 'ti-save', tags: [] },
    { name: 'ti-save-alt', tags: [] },
    { name: 'ti-yahoo', tags: [] },
    { name: 'ti-wordpress', tags: [] },
    { name: 'ti-vimeo-alt', tags: [] },
    { name: 'ti-twitter-alt', tags: [] },
    { name: 'ti-tumblr-alt', tags: [] },
    { name: 'ti-trello', tags: [] },
    { name: 'ti-stack-overflow', tags: [] },
    { name: 'ti-soundcloud', tags: [] },
    { name: 'ti-sharethis', tags: [] },
    { name: 'ti-sharethis-alt', tags: [] },
    { name: 'ti-reddit', tags: [] },
    { name: 'ti-pinterest-alt', tags: [] },
    { name: 'ti-microsoft-alt', tags: [] },
    { name: 'ti-linux', tags: [] },
    { name: 'ti-jsfiddle', tags: [] },
    { name: 'ti-joomla', tags: [] },
    { name: 'ti-html5', tags: [] },
    { name: 'ti-flickr-alt', tags: [] },
    { name: 'ti-email', tags: [] },
    { name: 'ti-drupal', tags: [] },
    { name: 'ti-dropbox-alt', tags: [] },
    { name: 'ti-css3', tags: [] },
    { name: 'ti-rss', tags: [] },
    { name: 'ti-rss-alt', tags: [] }
  ]
}
